const commons = {
    basePath: '/boards',
    singular: 'carte',
    plural: 'cartes'
}

export default  commons